<script>
import { Bar, mixins  } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'MBChart',
  extends: Bar,
  mixins: [reactiveProp],
  data: function() {
    return {
      options:{
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';
                    let value = tooltipItem.yLabel;
                    let unit = 'kB';
                    if (label) {
                        label += ': ';
                    }
                    if (value >= 1000000000) {
                      unit = 'TB';
                      value = Math.round(value / 1000000000 * 10) / 10
                    } else if (value >= 1000000) {
                      unit = 'GB';
                      value = Math.round(value / 1000000 * 10) / 10
                    } else if (value >= 1000) {
                      unit = 'MB';
                      value = Math.round(value / 1000 * 10) / 10
                    }

                    label += value + ' ' + unit;
                    return label;
                }
            }
        },
        scales: {
            xAxes: [{
                type: 'time',
                time: {
                  displayFormats:{
                    hour: 'DD/MM - H:mm',
                  },
                },
                distribution: 'series',
                stacked: true
            }],
            yAxes: [{
                stacked: true,
                ticks: {
                  min: 0,
                    callback: function(inputValue, index, values) {
                      let label = '';
                      let value = inputValue;
                      let unit = 'kB';
                      if (value >= 1000000000) {
                        unit = 'TB';
                        value = Math.round(value / 1000000000 * 10) / 10
                      } else if (value >= 1000000) {
                        unit = 'GB';
                        value = Math.round(value / 1000000 * 10) / 10
                      } else if (value >= 1000) {
                        unit = 'MB';
                        value = Math.round(value / 1000 * 10) / 10
                      }
                      label += value + ' ' + unit;
                      return label;
                    }
                }
            }]
        },
        plugins: {
          datalabels: false,
          labels: false
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>